/**
 * Internal dependencies
 */
const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  name: "core/pattern",
  title: "Pattern",
  category: "theme",
  description: "Show a block pattern.",
  supports: {
    html: false,
    inserter: false
  },
  textdomain: "default",
  attributes: {
    slug: {
      type: "string"
    }
  }
};
import PatternEdit from './edit';
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  edit: PatternEdit
};
//# sourceMappingURL=index.js.map